import React from 'react'
import clsx from 'clsx'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Skeleton from '@material-ui/lab/Skeleton'
import useStyles from '../styles'

const StatCard = ({
  label,
  value,
  caption,
  footnote,
  labelAction,
  valueClassName,
  children,
  className,
  labelClassName,
  captionClassName,
  loading,
  error,
}) => {
  const classes = useStyles()

  return (
    <Box className={clsx(classes.statCard, className)}>
      <Box className={classes.statHeader}>
        <Typography className={clsx(classes.statLabel, labelClassName)}>
          {label}
        </Typography>
        {labelAction}
      </Box>
      {loading ? (
        <Skeleton
          variant="rect"
          width={96}
          height={21}
          className={classes.statSkeleton}
        />
      ) : error ? (
        <Typography className={`${classes.statLabel} ${classes.messageError}`}>
          Unable to load
        </Typography>
      ) : (
        <Typography className={clsx(classes.statValue, valueClassName)}>
          {value}
        </Typography>
      )}
      {caption ? (
        <Typography className={clsx(classes.statCaption, captionClassName)}>
          {caption}
        </Typography>
      ) : null}
      {footnote ? (
        <Typography className={clsx(classes.statCaption, captionClassName)}>
          {footnote}
        </Typography>
      ) : null}
      {children}
    </Box>
  )
}

export default StatCard
